module.exports = __webpack_public_path__ + "static/media/shortinglistdown-white.0e85fc6d.svg";